
// 接口地址
const apiUrl = "https://api.sjzeis.com";

export default {
    apiUrl
};
